import React, { useEffect, useState } from 'react';
import '../App.css';
import { FaMoneyBillWave, FaChartBar } from 'react-icons/fa';


const APP_ID = 123359;
const API_TOKEN = 'QIZukwLIDzClWEl';
const WS_URL = `wss://ws.binaryws.com/websockets/v3?app_id=${APP_ID}`;

function Commission() {
  const currentMonth = new Date().toISOString().slice(0, 7);
  const [, setWs] = useState(null);
  const [commission, setCommission] = useState(null);
  const [todayCommission, setTodayCommission] = useState(null);
  const [monthlyTrend, setMonthlyTrend] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [error, setError] = useState(null);
  const [totalSinceApril, setTotalSinceApril] = useState(0);
  const [loadingTotal, setLoadingTotal] = useState(true);

  // ✅ Fetch Monthly Data
  useEffect(() => {
    if (!selectedMonth) return;
    const wsInstance = new WebSocket(WS_URL);
    setWs(wsInstance);

    wsInstance.onopen = () => {
      wsInstance.send(JSON.stringify({ authorize: API_TOKEN }));
    };

    wsInstance.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.msg_type === 'authorize') {
        const [year, month] = selectedMonth.split('-');
        const from = `${year}-${month}-01 00:00:00`;
        const toDate = new Date(year, parseInt(month), 0);
        const to = `${year}-${month}-${toDate.getDate()} 23:59:59`;

        wsInstance.send(
          JSON.stringify({
            app_markup_statistics: 1,
            date_from: from,
            date_to: to,
            req_id: 1,
          })
        );
      }
      if (data.msg_type === 'app_markup_statistics' && data.req_id === 1) {
        setCommission(data.app_markup_statistics);
      }
      if (data.msg_type === 'error') {
        setError(data.error.message);
      }
    };

    return () => wsInstance.close();
  }, [selectedMonth]);

  // ✅ Fetch Today’s Commission
  useEffect(() => {
    const wsInstance = new WebSocket(WS_URL);
    wsInstance.onopen = () => {
      wsInstance.send(JSON.stringify({ authorize: API_TOKEN }));
    };

    wsInstance.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.msg_type === 'authorize') {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');

        const from = `${yyyy}-${mm}-${dd} 00:00:00`;
        const to = `${yyyy}-${mm}-${dd} 23:59:59`;

        wsInstance.send(
          JSON.stringify({
            app_markup_statistics: 1,
            date_from: from,
            date_to: to,
            req_id: 2,
          })
        );
      }
      if (data.msg_type === 'app_markup_statistics' && data.req_id === 2) {
        setTodayCommission(data.app_markup_statistics);
      }
    };

    return () => wsInstance.close();
  }, []);

  // ✅ Fetch Commission for Past 5 Months
  useEffect(() => {
    const fetchMonthlyTrend = async () => {
      const results = [];
      for (let i = 4; i >= 0; i--) {
        const date = new Date();
        date.setMonth(date.getMonth() - i);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');

        const from = `${yyyy}-${mm}-01 00:00:00`;
        const toDate = new Date(yyyy, parseInt(mm), 0);
        const to = `${yyyy}-${mm}-${toDate.getDate()} 23:59:59`;

        const wsInstance = new WebSocket(WS_URL);
        await new Promise((resolve) => {
          wsInstance.onopen = () => {
            wsInstance.send(JSON.stringify({ authorize: API_TOKEN }));
          };
          wsInstance.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.msg_type === 'authorize') {
              wsInstance.send(
                JSON.stringify({
                  app_markup_statistics: 1,
                  date_from: from,
                  date_to: to,
                  req_id: 99,
                })
              );
            }
            if (data.msg_type === 'app_markup_statistics') {
              results.push({
                month: `${yyyy}-${mm}`,
                kes: Math.round((data.app_markup_statistics?.total_app_markup_usd || 0) * 126),
              });
              wsInstance.close();
              resolve();
            }
          };
        });
      }
      setMonthlyTrend(results);
    };

    fetchMonthlyTrend();
  }, []);

  // ✅ Fetch total commission since April 2025
  useEffect(() => {
    const fetchTotalSinceApril = async () => {
      setLoadingTotal(true);
      let totalUSD = 0;
      const now = new Date();
      const start = new Date(2025, 3, 1); // April 2025
      const monthsDiff = (now.getFullYear() - 2025) * 12 + (now.getMonth() - 3);
      for (let i = 0; i <= monthsDiff; i++) {
        const date = new Date(2025, 3 + i, 1);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const from = `${yyyy}-${mm}-01 00:00:00`;
        const toDate = new Date(yyyy, parseInt(mm), 0);
        const to = `${yyyy}-${mm}-${toDate.getDate()} 23:59:59`;

        const wsInstance = new WebSocket(WS_URL);
        await new Promise((resolve) => {
          wsInstance.onopen = () => {
            wsInstance.send(JSON.stringify({ authorize: API_TOKEN }));
          };
          wsInstance.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.msg_type === 'authorize') {
              wsInstance.send(
                JSON.stringify({
                  app_markup_statistics: 1,
                  date_from: from,
                  date_to: to,
                  req_id: 77,
                })
              );
            }
            if (data.msg_type === 'app_markup_statistics') {
              totalUSD += data.app_markup_statistics?.total_app_markup_usd || 0;
              wsInstance.close();
              resolve();
            }
          };
        });
      }
      const totalKES = totalUSD * 126;
      setTotalSinceApril(totalKES);
      setLoadingTotal(false);
    };

    fetchTotalSinceApril();
  }, []);

  const getAppTitle = (appId) => {
    if (appId === 70505) return '360 Trading';
    if (appId === 118496) return 'GLADIATORS';
    if (appId === 80598) return 'KIM TRADERS';
    if (appId === 123359) return 'Dollar Print';
    return `App ID: ${appId}`;
  };

  return (
    <div className="app-wrapper">
      
        <div className="app-container">
          <h1>
            <FaChartBar /> Admin Dashboard
          </h1>

          <label className="month-label">
            <input
              type="month"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            />
          </label>

          {/* 🔹 Commission Details */}
          <div className="commission-section">
            {commission ? (
            <div className="card-container">
              <div className="commission-card total-summary">
                <p className="total-mark-kes">
                  {Math.round(commission.total_app_markup_usd * 126).toLocaleString('en-KE')} /=
                </p>
                <p className="total-mark">
                  <span>${commission.total_app_markup_usd?.toFixed(2)}</span>
                </p>
                <p className="total-trades">
                  {commission.total_transactions_count ?? 0} Transactions
                </p>
              </div>

              {todayCommission && (
                <div className="commission-card today-summary">
                  <p className="text-header">Today’s Commission</p>
                  <p className="usd-data">
                    ${todayCommission.total_app_markup_usd?.toFixed(2)} 
                   
                  </p>
                  <p className="price-kes">
                    KES{' '}{(todayCommission.total_app_markup_usd * 126).toLocaleString('en-KE')}
                  </p>
                  <p className="green-text">
                    {todayCommission.total_transactions_count ?? 0} Trades
                  </p>
                </div>
              )}

              {commission.breakdown?.map((item) => (
                <div className="commission-card" key={item.app_id}>
                  <p className="text-header">
                    {getAppTitle(item.app_id)} <FaMoneyBillWave />
                  </p>
                  <p className="usd-data">${item.app_markup_usd?.toFixed(2)} </p>
                  <p className="price-kes">
                    KES{' '}
                    {(item.app_markup_usd * 126).toLocaleString('en-KE', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                  <p className="green-text">{item.transactions_count ?? 0} Trades</p>
                </div>
              ))}

              {/* 🧮 Total Since April 2025 
              <div className="commission-card special-total">
                <p className="text-header">Projection</p>
                {loadingTotal ? (
                  <div className="loading-total">
                    <div className="small-loader"></div>
                    <p>Calculating...</p>
                  </div>
                ) : (
                  <>
                    <p className="total-mark-kes">
                      {Math.round(totalSinceApril).toLocaleString('en-KE')} /=
                    </p>
                    <p className="total-mark">
                      <span>${(totalSinceApril / 126).toFixed(2)}</span>
                    </p>
                  </>
                )}
              </div>*/}
            </div>
                 ) : (
        <div className="loader-page">
          <div className="loader"></div>
          <p>Please wait...</p>
        </div>
      )}
            {error && <p className="error">{error}</p>}
          </div>

          {/* 📈 Line Chart for 5-Month Trend 
          {monthlyTrend.length > 0 && (
            <div className="chart-section">
              <h3>5 Months Chart</h3>
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={monthlyTrend}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month" />
                  <YAxis />
                  <Tooltip formatter={(v) => `KES ${v.toLocaleString()}`} />
                  <Line
                    type="monotone"
                    dataKey="kes"
                    stroke="#234581"
                    strokeWidth={3}
                    dot={{ r: 4 }}
                    activeDot={{ r: 6 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          )}*/}
          
        </div>
     
    </div>
  );
}

export default Commission;
